import { render, staticRenderFns } from "./InputUf.vue?vue&type=template&id=2f24c3f4"
import script from "./InputUf.vue?vue&type=script&lang=js"
export * from "./InputUf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports